import React from 'react'
import {
  BackLink,
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Stack,
} from '../../layout/styledComponents'

// Phase F1 ships a static crisis page so the red "Crisis support" rail item
// has something real behind it. The localized helpline list + auto-detected
// nearest emergency room arrive in Phase F6.

export default function CrisisPage() {
  return (
    <ContentMaxWidth>
      <Stack $gap="24px">
        <BackLink to="/patient-home/help">Back to Help</BackLink>
        <div>
          <Pill $tone="urgent">If you need help right now</Pill>
          <PageHeading style={{ marginTop: 12 }}>Crisis support</PageHeading>
          <PageSubheading>
            If you or someone you&apos;re with is in immediate danger, please reach out now.
          </PageSubheading>
        </div>

        <Card>
          <CardTitle>India — iCall</CardTitle>
          <Muted>9152987821 · Mon–Sat, 8am–10pm IST · Free, confidential.</Muted>
        </Card>
        <Card>
          <CardTitle>India — AASRA</CardTitle>
          <Muted>+91 9820466726 · 24/7.</Muted>
        </Card>
        <Card>
          <CardTitle>Emergency services</CardTitle>
          <Muted>
            Dial <strong>112</strong> (India), <strong>911</strong> (US/Canada), <strong>999</strong> (UK).
          </Muted>
        </Card>
        <Card>
          <CardTitle>Reach your practitioner</CardTitle>
          <Muted>
            Open <strong>Messages</strong> from the navigation to send your therapist or doctor a
            note. They will be paged according to their availability.
          </Muted>
        </Card>
      </Stack>
    </ContentMaxWidth>
  )
}
